export default "__VITE_ASSET__872ac4aa__"